"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeerDiscovery = void 0;
const is_url_superb_1 = __importDefault(require("is-url-superb"));
const ky_universal_1 = __importDefault(require("ky-universal"));
const lodash_orderby_1 = __importDefault(require("lodash.orderby"));
const semver_1 = __importDefault(require("semver"));
class PeerDiscovery {
    constructor(seeds) {
        Object.defineProperty(this, "seeds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: seeds
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "latency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderBy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ["latency", "desc"]
        });
    }
    static async new(connection, networkOrUrl) {
        let seeds = [];
        if (typeof networkOrUrl === "string") {
            if (networkOrUrl === "mainnet" || networkOrUrl === "devnet") {
                try {
                    seeds = await ky_universal_1.default
                        .get(`https://raw.githubusercontent.com/ArkEcosystem/peers/master/${networkOrUrl}.json`)
                        .json();
                }
                catch {
                    throw new Error("Failed to discovery any peers.");
                }
            }
            else {
                if (is_url_superb_1.default(networkOrUrl)) {
                    try {
                        seeds = (await ky_universal_1.default.get(networkOrUrl).json()).data;
                    }
                    catch {
                        throw new Error("Failed to discovery any peers.");
                    }
                }
                else {
                    throw new Error("Failed to discovery any peers, because the url is wrong");
                }
            }
        }
        else {
            if (connection) {
                try {
                    seeds = (await connection.get("peers")).body.data;
                }
                catch {
                    throw new Error("Failed to discovery any peers.");
                }
            }
            else {
                throw new Error("No connection, network or url specified");
            }
        }
        if (!seeds.length) {
            throw new Error("No seeds found");
        }
        return new PeerDiscovery(seeds);
    }
    getSeeds() {
        return this.seeds;
    }
    withVersion(version) {
        this.version = version;
        return this;
    }
    withLatency(latency) {
        this.latency = latency;
        return this;
    }
    sortBy(key, direction = "desc") {
        this.orderBy = [key, direction];
        return this;
    }
    async findPeers(opts = {}) {
        if (!opts.retry) {
            opts.retry = { limit: 0 };
        }
        if (!opts.timeout) {
            opts.timeout = 3000;
        }
        const selectProperPeer = () => {
            const peer = this.seeds[Math.floor(Math.random() * this.seeds.length)];
            if (peer === null || peer === void 0 ? void 0 : peer.plugins) {
                const coreApiPlugin = peer.plugins["@arkecosystem/core-api"];
                if (!coreApiPlugin) {
                    return selectProperPeer();
                }
                if (coreApiPlugin.port) {
                    return peer;
                }
                return selectProperPeer();
            }
            return selectProperPeer();
        };
        const seed = selectProperPeer();
        const body = await ky_universal_1.default(`http://${seed.ip}:${seed.plugins["@arkecosystem/core-api"].port}/api/peers`, {
            ...opts,
            ...{
                headers: {
                    "Content-Type": "application/json",
                },
            },
        }).json();
        let peers = body.data;
        if (this.version) {
            peers = peers.filter((peer) => semver_1.default.satisfies(peer.version, this.version));
        }
        if (this.latency) {
            peers = peers.filter((peer) => peer.latency <= this.latency);
        }
        return lodash_orderby_1.default(peers, this.orderBy[0], this.orderBy[1]);
    }
    async findPeersWithPlugin(name, opts = {}) {
        const peers = [];
        for (const peer of await this.findPeers(opts)) {
            if (peer.plugins) {
                const pluginName = Object.keys(peer.plugins).find((key) => key.split("/")[1] === name);
                if (pluginName) {
                    const port = peer.plugins[pluginName].port;
                    if (port >= 1 && port <= 65535) {
                        peers.push(peer);
                    }
                }
            }
        }
        return peers;
    }
    async findPeersWithoutEstimates(opts = {}) {
        const apiPeers = await this.findPeersWithPlugin("core-api", opts);
        const requests = apiPeers.map((peer) => {
            return ky_universal_1.default.get(`http://${peer.ip}:${peer.plugins["@arkecosystem/core-api"].port}/api/blocks?limit=1`).json();
        });
        const responses = await Promise.all(requests);
        const peers = [];
        for (const i in responses) {
            const apiPeer = apiPeers[i];
            if (!responses[i].meta.totalCountIsEstimate && apiPeer) {
                peers.push(apiPeer);
            }
        }
        return peers;
    }
}
exports.PeerDiscovery = PeerDiscovery;
//# sourceMappingURL=peer-discovery.js.map